import Model from '@/models/Model.js';

export default class AutomatedSurveyTarget extends Model {
    static entity = 'automated_survey_targets';

    static modelName = 'AutomatedSurveyTarget';

    static fields() {
        return {
            id: this.attr(null),
            automated_survey_id: this.attr(null),
            targetable_id: this.attr(null),
            targetable_type: this.attr(null),
            targetable_type_entity: this.attr(null),
            is_for_students: this.attr(null),
            is_for_instructors: this.attr(null),
            is_for_group_instructors: this.attr(null),
            scope: this.attr(null),
            estimated_count: this.number(0),

            ...super.fields(),

            automatedSurvey: this.belongsTo('automated_surveys', 'automated_survey_id'),
            targetable: this.morphTo('targetable_id', 'targetable_type_entity'),
        };
    }
}
